import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-upload-logs',
  templateUrl: './upload-logs.component.html',
  styleUrls: ['./upload-logs.component.css'],
})
export class UploadLogsComponent extends BaseListCtl {
  usecaseId: number = 0;
  uploadLogs: any[] = [];
  errorDetails: any[] = [];
  currentUploadId: number = 0;
  showErrorDetails: boolean = false;

  masterSelectedLogs: boolean = false;
  masterSelectedErrors: boolean = false;
  private errorLogsCollection: string = '';
  private errorDetailsCollection: string = '';
  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
    
  ) {
    super('', locator, route);
  }

override ngOnInit(): void {
  this.errorLogsCollection = this.locator.config.get('collection.upload-error-logs');
  this.errorDetailsCollection = this.locator.config.get('collection.upload-error-details');

  this.route.paramMap.subscribe(params => {

    const usecaseId = params.get('usecaseId');
    const uploadId = params.get('uploadId');

    this.usecaseId =  Number(usecaseId);;

    if (uploadId) {
      this.viewErrors(Number(uploadId));
    } else {
      this.fetchUploadHistory();
    }

  });

}

  //  PAGINATION HOOK
  override search(callback?: any): void {
    if (this.showErrorDetails) {
      this.viewErrors(this.currentUploadId);
    } else {
      this.fetchUploadHistory();
    }
  }

  //  UPLOAD HISTORY 
  fetchUploadHistory() {
    let _self = this;

    const collectionName = this.errorLogsCollection.replace(/\./g, '/');
    const url =
      _self.locator.config.get('endpoint.api.v1') +
      '/' + collectionName +
      '/search/' + _self.form.pageNo;

    const searchData: any = {
      userstoryId: _self.usecaseId,
      orderBy: 'createdDatetime',
      asc: 'DESC',
      pageSize: _self.form.pageSize,
    };

    _self.locator.http.post(url, searchData, function (res: any, error: any) {
      if (error) {
        alert('Failed to load upload history');
        _self.uploadLogs = [];
        return;
      }

      if (res.success && res.result?.data) {
        _self.uploadLogs = res.result.data;
        _self.masterSelectedLogs = false;

        //  Pagination state 
        _self.form.pageCount = res.result.pageCount;
        _self.form.pageSize = res.result.pageSize;
        _self.form.pageNos = res.result.pageNo;
        _self.form.pageNoList = [];
        for (let i = 0; i < _self.form.pageCount; i++) {
          _self.form.pageNoList.push(i);
        }

        if (_self.uploadLogs.length === 0) {
          _self.form.message = 'No upload history found';
          _self.form.error = true;
        }
      } else {
        _self.uploadLogs = [];
      }
    });
  }

  //  ERROR DETAILS 
  viewErrors(uploadId: number) {
    let _self = this;
    _self.currentUploadId = uploadId;
    _self.showErrorDetails = true;

    const collectionName = this.errorDetailsCollection.replace(/\./g, '/');
    const url =
      _self.locator.config.get('endpoint.api.v1') +
      '/' + collectionName +
      '/search/' + _self.form.pageNo;

    const searchData: any = {
      uploadId: uploadId,
      orderBy: 'rowNumber',
      asc: 'ASC',
      pageSize: _self.form.pageSize,
    };

    _self.locator.http.post(url, searchData, function (res: any, error: any) {
      if (error) {
        alert('Failed to load error details');
        _self.errorDetails = [];
        return;
      }

      if (res.success && res.result?.data) {
        _self.errorDetails = res.result.data;
        _self.masterSelectedErrors = false;

        // Pagination state 
        _self.form.pageCount = res.result.pageCount;
        _self.form.pageSize = res.result.pageSize;
        _self.form.pageNos = res.result.pageNo;
        _self.form.pageNoList = [];
        for (let i = 0; i < _self.form.pageCount; i++) {
          _self.form.pageNoList.push(i);
        }

        if (_self.errorDetails.length === 0) {
          _self.form.message = 'No errors found';
          _self.form.error = true;
        }
      } else {
        _self.errorDetails = [];
      }
    });
  }

  backToHistory() {
    this.showErrorDetails = false;
    this.errorDetails = [];
    this.currentUploadId = 0;
    this.masterSelectedErrors = false;
    // Reset pagination for history table
    this.form.pageNo = 0;
    this.fetchUploadHistory();
  }

  //  DELETE ONE LOG 
  // deleteLog(id: number) {
  //   let _self = this;
  //   const flag = confirm('Are you sure you want to delete this upload log?');
  //   if (!flag) return;

  //   const collectionName = 'cuickdev.upload-error-logs'.replace(/\./g, '/');
  //   const url =
  //     _self.locator.config.get('endpoint.api.v1') +
  //     '/' + collectionName +
  //     '/delete/' + id;

  //   _self.locator.http.get(url, function (res: any, error: any) {
  //     if (error) {
  //       alert('Server Error: ' + error);
  //       return;
  //     }
  //     _self.form.error = !res.success;
  //     _self.form.message = res.message;
  //     if (res.success) {
  //       _self.fetchUploadHistory();
  //     }
  //   });
  // }

  //  DELETE ALL SELECTED LOGS 
  deleteAllSelectedLogs() {
    let _self = this;
    const selected = _self.uploadLogs.filter((item) => item.selected);
    if (selected.length === 0) {
      alert('Please select at least one record to delete.');
      return;
    }

    const flag = confirm(
      `Are you sure you want to delete ${selected.length} selected log(s)?`
    );
    if (!flag) return;

    const collectionName = this.errorLogsCollection.replace(/\./g, '/');
    let completed = 0;
    const deletedIds: number[] = [];

    selected.forEach((item: any) => {
      const url =
        _self.locator.config.get('endpoint.api.v1') +
        '/' + collectionName +
        '/delete/' + item.id;

      _self.locator.http.get(url, function (res: any, error: any) {
        completed++;
        if (!error && res.success) {
          deletedIds.push(item.id);
        }
        if (completed === selected.length) {
          _self.uploadLogs = _self.uploadLogs.filter(
            (log) => !deletedIds.includes(log.id)
          );
          _self.masterSelectedLogs = false;
          _self.fetchUploadHistory();
        }
      });
    });
  }

  // DELETE ONE ERROR DETAIL 
  deleteErrorDetail(id: number) {
    let _self = this;
    const flag = confirm('Are you sure you want to delete this error record?');
    if (!flag) return;

    const collectionName = this.errorDetailsCollection.replace(/\./g, '/');
    const url =
      _self.locator.config.get('endpoint.api.v1') +
      '/' + collectionName +
      '/delete/' + id;

    _self.locator.http.get(url, function (res: any, error: any) {
      if (error) {
        alert('Server Error: ' + error);
        return;
      }
      _self.form.error = !res.success;
      _self.form.message = res.message;
      if (res.success) {
        _self.viewErrors(_self.currentUploadId);
      }
    });
  }

  //  DELETE ALL SELECTED ERROR DETAILS 
  deleteAllSelectedErrors() {
    let _self = this;
    const selected = _self.errorDetails.filter((item) => item.selected);
    if (selected.length === 0) {
      alert('Please select at least one record to delete.');
      return;
    }

    const flag = confirm(
      `Are you sure you want to delete ${selected.length} selected error(s)?`
    );
    if (!flag) return;

    const collectionName = this.errorDetailsCollection.replace(/\./g, '/');
    let completed = 0;
    const deletedIds: number[] = [];

    selected.forEach((item: any) => {
      const url =
        _self.locator.config.get('endpoint.api.v1') +
        '/' + collectionName +
        '/delete/' + item.id;

      _self.locator.http.get(url, function (res: any, error: any) {
        completed++;
        if (!error && res.success) {
          deletedIds.push(item.id);
        }
        if (completed === selected.length) {
          _self.errorDetails = _self.errorDetails.filter(
            (err) => !deletedIds.includes(err.id)
          );
          _self.masterSelectedErrors = false;
          _self.viewErrors(_self.currentUploadId);
        }
      });
    });
  }

  // CHECKBOX HELPERS 
  selectAllLogs() {
    this.uploadLogs.forEach((item) => (item.selected = this.masterSelectedLogs));
  }

  checkIfAllLogsSelected() {
    this.masterSelectedLogs = this.uploadLogs.every((item) => item.selected);
  }

  selectAllErrors() {
    this.errorDetails.forEach(
      (item) => (item.selected = this.masterSelectedErrors)
    );
  }

  checkIfAllErrorsSelected() {
    this.masterSelectedErrors = this.errorDetails.every(
      (item) => item.selected
    );
  }

  // DELETE ONE LOG + ITS ERROR DETAILS
  deleteLog(id: number) {
    let _self = this;
    const flag = confirm('Are you sure you want to delete this upload log and all its error details?');
    if (!flag) return;

    // Step 1: Fetch all error details for this uploadId
    const errorCollection = _self .errorDetailsCollection.replace(/\./g, '/');
    const searchUrl =
      _self.locator.config.get('endpoint.api.v1') +
      '/' + errorCollection +
      '/search/0';

    const searchData: any = {
      uploadId: id,
      orderBy: 'rowNumber',
      asc: 'ASC',
      pageSize: 9999, // fetch all
    };

    _self.locator.http.post(searchUrl, searchData, function (res: any, error: any) {
      const errorIds: number[] =
        !error && res.success && res.result?.data
          ? res.result.data.map((e: any) => e.id)
          : [];

      // Step 2: Delete all error details first, then delete the log
      const deleteLogFn = () => {
        const logCollection = _self .errorLogsCollection.replace(/\./g, '/');
        const logUrl =
          _self.locator.config.get('endpoint.api.v1') +
          '/' + logCollection +
          '/delete/' + id;

        _self.locator.http.get(logUrl, function (res: any, error: any) {
          if (error) { alert('Server Error: ' + error); return; }
          _self.form.error = !res.success;
          _self.form.message = res.message;
          if (res.success) _self.fetchUploadHistory();
        });
      };

      if (errorIds.length === 0) {
        deleteLogFn(); // No errors, directly delete log
        return;
      }

      let completed = 0;
      errorIds.forEach((errorId: number) => {
        const url =
          _self.locator.config.get('endpoint.api.v1') +
          '/' + errorCollection +
          '/delete/' + errorId;

        _self.locator.http.get(url, function () {
          completed++;
          if (completed === errorIds.length) {
            deleteLogFn(); // All errors deleted, now delete log
          }
        });
      });
    });
  }
 
}